import React,{ useState } from "react";

import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import servicioObjetos from "../../../servicio/ServicioObjetos";
import servicioFormatos from "../../../servicio/ServicioFormatos";

export const ModalDetalleMovimientos = (props) => {

    const {mostrar, cerrar, nombreArchivo,paginacion } = props;

    const onIndexTemplate = (data, props) => {
        return (props.rowIndex + 1);
    }

    const columnaNombreTrabajador = (rowData, column) => {
        const nombre = servicioObjetos.stripToEmpty(rowData.nombre) + " " + servicioObjetos.stripToEmpty(rowData.appPaterno) + " " +
            servicioObjetos.stripToEmpty(rowData.appMaterno);
        return <strong>{nombre}</strong>;
    }

    const columnaFechaMovimiento = (rowData, column) => {
        return servicioFormatos.formatearFecha(rowData.fechaMovimientoDate);
    }

    return (
        <div>

            <Dialog header={"Detalle archivo " + nombreArchivo} visible={mostrar} style={{ width: '50vw' }} 
            modal={true} onHide={cerrar}>
                
                <DataTable
                value={paginacion.datos}
                responsive={true}
                header="Empresa"
                autoLayout={true} 
                selectionMode="single">
                <Column field="Index" header="Número" body={onIndexTemplate} />
                <Column field="numeroSeguridadSocial" header="Numero Seguridad Social" />             
                <Column header="Nombre Completo Trabajador" body={columnaNombreTrabajador}/>
                <Column field="tipoMovimiento" header="Tipo de Movimiento" />
                <Column header="Fecha Movimiento" body={columnaFechaMovimiento}/>
                <Column field="descripcionError" header="Error al enviar al IDSE" />
                <Column field="descripcionErrorAfil" header="Error de respuesta del IMSS" />
            </DataTable>
            </Dialog>
        </div>
    );
}